import BaseVitalCard, { VitalCardConfig } from "../../../Common/BaseVitalCard";
import { WellnessScoreStatus } from "../../../Common/types";

export interface BloodPressureCardProps {
  metricValue: string;
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onManualEntryClick?: () => void;
}

const config: VitalCardConfig = {
  translationPrefix: "BloodPressure",
  analyticsSource: "Health Score - blood pressure",
  manualEntryRoute: "/home/health-score/blood-pressure-manual-entry",
};

export default function BloodPressureCard(
  props: BloodPressureCardProps
): JSX.Element {
  return <BaseVitalCard {...props} config={config} />;
}
